import axios from "@/axios";

const getDefaultState = () => ({
    leituras: [],
    leitura: {}
});

const state = getDefaultState();

const mutations = {
    SET_LEITURAS(state, leituras) {
      state.leituras = leituras;
    },
    SET_LEITURA(state, leitura) {
        state.leitura = leitura;
    },
    reset(state) {
        Object.assign(state, getDefaultState());
    }
}

const actions = {
    async fetchLeiturasBySilo({ commit }, siloId ) {
        try {
            const response = await axios.get(`/silos/${siloId}/leituras`);
            commit('SET_LEITURAS', response.data);
            return response.data
        } catch (error) {
            console.error("Erro ao buscar leituras do silo:", error);
			throw error;
        }
    },
    async fetchLeituraById({ commit }, body) {
        try {
            const response = await axios.get(`/silos/${body.siloId}/leituras/${body.leituraId}`)
            commit('SET_LEITURA', response.data);
            return response.data
        } catch (error) {
            console.error("Erro ao buscar leitura: ", error)
            throw error;
        }
    },
    async downloadRelatorioTermometriaLotePdf(_, { unidadeId, silo_ids, leitura_referencia_id, janela_minutos, habilita_cor }) {
        try {
            const response = await axios.post(
                `/unidades/${unidadeId}/termometria/relatorio/pdf`,
                { silo_ids, leitura_referencia_id, janela_minutos, habilita_cor },
                { responseType: 'blob' }
            );
            return response;
        } catch (error) {
            console.error("Erro ao gerar PDF do relatório de termometria:", error);
            throw error;
        }
    },
    async uploadLeitura(_, body) {
        try {
            const formData = new FormData();
            formData.append('file', body.json);

            const response = await axios.post(`/silos/${body.siloId}/leituras/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async fetchLeiturasTermometriaEmLote(_, { unidadeId, silo_ids, data_inicio, data_final }) {
        try {
            const response = await axios.post(`/unidades/${unidadeId}/termometria/leituras`, {
                silo_ids, data_inicio, data_final
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar leituras em lote:", error);
            throw error;
        }
    },
    async fetchRelatorioTermometriaEmLote(_, { unidadeId, silo_ids, leitura_referencia_id, janela_minutos }) {
        try {
            const response = await axios.post(`/unidades/${unidadeId}/termometria/relatorio`, {
                silo_ids, leitura_referencia_id, janela_minutos
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao gerar relatório de termometria em lote:", error);
            throw error;
        }
    },
    async excluirLeiturasTermometriaEmLote(_, { unidadeId, leitura_ids }) {
        try {
            const response = await axios.post(`/unidades/${unidadeId}/termometria/leituras/excluir`, {
                leitura_ids
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao excluir leituras:", error);
            throw error;
        }
    },
    async getLeiturasAutomaticas(_, unidadeId ) {
        try {
            const response = await axios.get(`/unidades/${unidadeId}/leituras/automaticas`);
            return response.data
        } catch (error) {
            console.error("Erro ao buscar leituras automáticas:", error);
			throw error;
        }
    },

    async salvarLeiturasAutomaticas(_, {unidadeId, horariosASalvar}) {
        try {
            return await axios.post(`/unidades/${unidadeId}/leituras/automaticas`, horariosASalvar);
        } catch (error) {
            console.error("Erro ao salvar leituras automáticas:", error);
			throw error;
        }
    },
};

export default {
    namespaced: true,
    actions,
    mutations,
    state
}